import React, { useState } from "react"
import { Form } from "react-final-form"
import createDecorator from "final-form-focus"
import { Button } from "react-bootstrap"
import { animateScroll as scroll } from "react-scroll"

export default function Wizard(props) {
  const [page, setPage] = useState(0)
  const [values, setValues] = useState(props.initialValues || {})
  const focusOnErrors = createDecorator()

  const next = values => {
    setValues(values)
    setPage(Math.min(page + 1, props.children.length - 1))
    scroll.scrollToTop({ duration: 500 })
  }

  const previous = () => {
    setPage(Math.max(page - 1, 0))
    scroll.scrollToTop({ duration: 500 })
  }

  /**
   * NOTE: Both validate and handleSubmit switching are implemented
   * here because 🏁 Redux Final Form does not accept changes to those
   * functions once the form has been defined.
   */

  const validate = values => {
    const activePage = React.Children.toArray(props.children)[page]
    return activePage.props.validate ? activePage.props.validate(values) : {}
  }

  const handleSubmit = vals => {
    const { children, onSubmit } = props
    const isLastPage = page === React.Children.count(children) - 1
    if (isLastPage) {
      props.handleSubmit(vals)
    } else {
      next(vals)
    }
  }

  const { children } = props
  const activePage = React.Children.toArray(children)[page]
  const isLastPage = page === React.Children.count(children) - 1

  return (
    <Form
      initialValues={values}
      validate={validate}
      onSubmit={handleSubmit}
      decorators={[focusOnErrors]}
    >
      {({ handleSubmit, submitting, values }) => (
        <form onSubmit={handleSubmit}>
          {activePage}
          <div className="buttons text-center my-5 pb-5">
            {page > 0 && (
              <Button type="Button" onClick={previous}>
                « Previous Step
              </Button>
            )}
            {page == 0 && <Button type="submit">Enroll Now »</Button>}
            {page > 0 && page < 2 && (
              <Button type="submit" className="ml-3">
                Next Step »
              </Button>
            )}
            {/* {page === 2 && (
              <Button type="submit" className="ml-3">
                Next Step »
              </Button>
            )} */}
            {isLastPage && (
              <Button
                type="submit"
                disabled={!props.submitEnabled}
                className="ml-3"
              >
                Submit Enrollment
              </Button>
            )}
          </div>
          {/* <pre>
            <FormSpy>{props => JSON.stringify(props, null, 2)}</FormSpy>
          </pre> */}
        </form>
      )}
    </Form>
  )
}

Wizard.Page = ({ children }) => children
